<div [id]="form.displayId()">
    @if (form.formView().value() === ELoginEduView.modal) {
        <div class="login-edu-button-group widget-specific-nav-align" [style]="buttonGroupVars()">
            @if (isAuthorizationTriggerActive()) {
                <a
                    [class]="getTriggerButtonClass($any(form.authorizationTrigger()), 'authorization')"
                    [style]="getTriggerVars($any(form.authorizationTrigger()))"
                >
                    @if (form.authorizationTrigger()?.buttonIcon?.isActive) {
                        <span class="icon" [innerHTML]="getIcon(form.authorizationTrigger()!.buttonIcon!.icon)"></span>
                    }
                    {{ form.authorizationButtonLabel() }}
                </a>
            }
            @if (form.isRegistrationTriggerActive()) {
                <a
                    [class]="getTriggerButtonClass($any(form.registrationTrigger()), 'registration')"
                    [style]="getTriggerVars($any(form.registrationTrigger()))"
                >
                    @if (form.registrationTrigger()?.buttonIcon?.isActive) {
                        <span class="icon" [innerHTML]="getIcon(form.registrationTrigger()!.buttonIcon!.icon)"></span>
                    }
                    {{ form.registrationButtonLabel() }}
                </a>
            }
            @for (button of form.buttons().value(); track $index) {
                @if (button.buttonType === "default" && isButtonActive(button)) {
                    <a
                        [class]="getButtonClass($any(button))"
                        [style]="getButtonVars($any(button))"
                        [href]="button.link?.url"
                        [target]="button.isTargetBlank ? '_blank' : '_self'"
                    >
                        {{ button.label }}
                    </a>
                }
            }
        </div>
    }
    @if (form.formView().value() === ELoginEduView.static) {
        @if (isRegisterForm()) {
            <web-register-form-view
                [data]="registrationButtonData()"
                [showAuthorizationFormLink]="isShowAuthorizationFormLink()"
                [courseTariffDetails]="$any(form.courseTariffDetails().value())"
                [course]="$any(form.course().value())"
            />
        }
        @if (isLoginForm()) {
            <web-login-form-view
                [data]="authorizationButtonData()"
                [showRegistrationFormLink]="form.isShowRegistrationFormLink()"
            />
        }
    }
</div>
